import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarDisable1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-width:1.5px;}.a{stroke-linecap:round;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "calendar-disable-1" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 17.25,
			cy: 17.25,
			r: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 19.5,
			y1: 15,
			x2: 15,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15,
			y1: 15,
			x2: 19.5,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,17.25h-6a1.5,1.5,0,0,1-1.5-1.5V3.765a1.5,1.5,0,0,1,1.5-1.5h13.5a1.5,1.5,0,0,1,1.5,1.5V8.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "b",
			x1: .75,
			y1: 6.75,
			x2: 17.25,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.243,
			y1: 3.75,
			x2: 5.243,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.743,
			y1: 3.75,
			x2: 12.743,
			y2: .75
		})
	]
});
export default SvgCalendarDisable1;
